import { notification } from 'antd'

const applyNotificationConfig = () => {
    notification.config({
        maxCount: 5,
        duration: 10,
    })
}

export default applyNotificationConfig
